/**
 * Meta Pixel Event Utilities
 * Pixel ID: 916466638089647
 */

const safeFbq = (...args) => {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq(...args);
  }
};

/**
 * Track ViewContent event when a product detail is viewed
 * @param {Object} product - Product object with id, price, title
 */
export const trackViewContent = (product) => {
  if (!product?.id) return;
  safeFbq('track', 'ViewContent', {
    content_ids: [String(product?.id)],
    content_type: 'product',
    content_name: product?.title || '',
    value: parseFloat(product?.price) || 0,
    currency: 'TRY',
  });
};

/**
 * Track AddToCart event when a product is added to cart
 * @param {Object} product - Product object with id, price, title
 */
export const trackAddToCart = (product) => {
  if (!product?.id) return;
  safeFbq('track', 'AddToCart', {
    content_ids: [String(product?.id)],
    content_type: 'product',
    content_name: product?.title || '',
    value: parseFloat(product?.price) || 0,
    currency: 'TRY',
  });
};

/**
 * Track Purchase event when an order is completed
 * @param {string|number} orderId - Order ID
 * @param {number} totalAmount - Total order amount
 * @param {Array} items - Array of order items with id and price
 */
export const trackPurchase = (orderId, totalAmount, items = []) => {
  const contentIds = items?.map((item) => String(item?.id || item?.product_id))?.filter(Boolean);
  safeFbq('track', 'Purchase', {
    content_ids: contentIds?.length > 0 ? contentIds : [String(orderId)],
    content_type: 'product',
    value: parseFloat(totalAmount) || 0,
    currency: 'TRY',
    order_id: String(orderId),
    num_items: items?.length || 1,
  });
};
